// import Vue from './main';
import {
  Breadcrumb,
  BreadcrumbItem,
  Select,
  Option,
  Checkbox,
  Input,
  Button,
  Pagination,
  Dialog,
  InputNumber,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Loading,
} from "element-ui";
import wish from "./lib/directives/wish";
import { cartMixin } from "./lib/mixins/cart";
import { i18n, loadLanguageAsync } from "./lib/i18n";
import { getLangPath } from "./lib/i18n/getLang";
import goodsList from "./components/goodsListHot";
import store from "./lib/local/cart";
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Input);
Vue.use(Button);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(InputNumber);
Vue.use(Loading);
loadLanguageAsync("hot");
new Vue({
  i18n: i18n,
  mixins: [cartMixin],
  directives: { wish },
  el: "#app",
  components: {
    goodsList,
  },
  data() {
    return {
      tips_text_arr: [],
      goodsList: [],
      selectList: {},
      link: [],
      getListParams: {
        category_id: [],
        brand_id: [],
        sorting: 0,
        size: 20,
      },
      routeId: null,
      goodsListLoading: 0,
    };
  },
  created() {
    const href = window.location.href;
    const search = window.location.search;
    if (!search) {
      this.routeId = href.slice(href.indexOf("category/") + 9);
    } else {
      this.routeId = href.slice(
        href.indexOf("category/") + 9,
        href.indexOf("?")
      );
    }
    let initData =
      store.state.memoryData["category"] &&
      store.state.memoryData["category"][this.routeId];
    if (initData) {
      this.getListParams = initData;
    }
    if (this.routeId) {
      this.getListParams.category_id.push(this.routeId)
    }
    this.getList(initData && initData.url);
    this.getSelectList();
  },
  methods: {
    memory(url) {
      store.commit("MEMORY_SELEAT", {
        name: "category",
        ...this.getListParams,
        // categoryId: this.routeId,
        url: url,
      });
    },
    getList(url) {
      this.goodsListLoading++;
      this.$json
        .post(
          // url || `product/api/categories/${this.routeId}`,
          url || `product/api`,
          this.getListParams
        )
        .then((res) => {
          if (res.ret && this.goodsListLoading === 1) {
            res.data.data.forEach((e) => {
              const numList = []
              e.goods.forEach(s => {
                if (s.num > 0) {
                  numList.push(s.num)
                }
              })
              if (numList.length > 0) {
                e.isSoom = true;
              }
            });
            this.goodsList = res.data.data;
            this.link = res.data.links;
          }
        })
        .finally(() => this.goodsListLoading--);
    },
    checkChange(arr) {
      this.getListParams.category_id = arr;
      this.memory();
      this.getList();
    },
    selectChange(arr) {
      this.getListParams.brand_id = arr;
      this.memory();
      this.getList();
    },
    // 排序
    sortChange(val) {
      this.getListParams.sorting = val;
      this.memory();
      this.getList();
    },
    // 分页被点击
    pageChange(url) {
      this.memory(url);
      this.getList(url);
    },
    getSelectList() {
      this.$json.post(`filter/api/categories/${this.routeId}`).then((res) => {
        if (res.ret) {
          this.selectList = res.data;
        }
      });
    },
  },
});



// WEBPACK FOOTER //
// ./resources/js/category.js